import axios from 'axios';

// React state and router.
import { useEffect, useState } from 'react'

// Firebase.
import { getAnalytics, logEvent } from "firebase/analytics";

// Constants.
import { useLocation, useNavigate } from 'react-router-dom';
import PodcastView from '../components/PodcastView';

const LOADING_MESSAGES = [
    "Loading show",
    "Searching for RSS feed",
    "Reading show details",
    "Processing episodes",
    "Making the final touches",
];

const LoadPodcast = () => {
    const analytics = getAnalytics();
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState("");
    const [imageSrc, setImageSrc] = useState("");
    const [error, setError] = useState(null);
    const [podcast, setPodcast] = useState(null);
    const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);


    const { state } = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        let active = true;
        if (state && state.title && state.rssURL) {
            setTitle(state.title);
            setImageSrc(state.imageSrc || "");
            setLoadingMessageIndex(0);
            setLoading(true);
            axios
                .post('/unknown_podcast', {
                    podcastName: state.title,
                    rssURL: state.rssURL,
                    ...(state.appleCollectionId ? { appleCollectionId: state.appleCollectionId } : {}),
                })
                .then((res) => {
                    if (!active) return;
                    setLoading(false);
                    setPodcast(res.data);
                    navigate(`/podcast/${res.data.id}`, { replace: true });
                })
                .catch((err) => {
                    if (!active) return;
                    setLoading(false);
                    setError("Unable to load show.");
                });
        } else {
            setError("Unable to load show.");
        }

        logEvent(analytics, 'screen_view', {
            firebase_screen: 'load_podcast'
        });
        return () => { active = false; };
    }, [analytics, navigate, state]);

    useEffect(() => {
        if (!loading) {
            if (loadingMessageIndex !== 0) {
                setLoadingMessageIndex(0);
            }
            return;
        }

        if (loadingMessageIndex >= LOADING_MESSAGES.length - 1) {
            return;
        }

        const timeoutId = window.setTimeout(() => {
            setLoadingMessageIndex((currentIndex) => Math.min(currentIndex + 1, LOADING_MESSAGES.length - 1));
        }, 2400);

        return () => window.clearTimeout(timeoutId);
    }, [loading, loadingMessageIndex]);


    return (
        <div>
            {!!podcast ?
                <PodcastView podcast={podcast} /> :
                <div className="center" style={{ textAlign: 'center', width: '340px' }}>
                    {error ?
                        <div style={{ marginTop: '-60px' }}>
                            <div style={{ fontSize: '60px', padding: '20px' }}>😔</div>
                            <div className='subheading'>
                                {error}
                            </div>
                            <div style={{ padding: '10px 20px', margin: '10px', background: 'var(--app-surface-tertiary)', borderRadius: '10px' }}>
                                <a href="/">home</a>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='heading' style={{ marginTop: '-60px', marginBottom: '20px' }}>
                                {title}
                            </div>
                            {!!imageSrc && (
                                <div>
                                    <img className='podcastArtwork' src={imageSrc} alt='' style={{ margin: '10px', width: '44px', height: '44px', objectFit: 'contain' }} />
                                </div>
                            )}
                            {loading ?
                                <div className='subheading glow'>
                                    <div>{LOADING_MESSAGES[loadingMessageIndex]}</div>
                                </div>
                                : <></>
                            }
                        </div>
                    }
                </div>
            }
        </div >
    );
}


export default LoadPodcast;
